import React from 'react';
import { FaAward,FaBook,FaCalendarAlt } from 'react-icons/fa';
import { VscFolderLibrary } from 'react-icons/vsc';
import { ImLocation } from 'react-icons/im';
import { FiChevronRight } from 'react-icons/fi';
// import ME from '../../assets/Vivek.jpeg';
import ME from '../../assets/Vivek1.JPG';
import './intro.css';

const Intro1 = () => {
  return (
    <section id="about">
      <h5 style={{color:"#6b6767"}}>Get to know</h5>
      <h2 >About Me</h2>
      <div className="container about__container">
        

        <div className='eduDiv' style={{justifyContent:"center",marginTop:"2rem"}}>

        <div className='edu' style={{display:"flex",justifyContent:"center",alignItems:"center",marginBottom:"50px"}}>
            <p style={{color:"var(--color-primary)",fontSize:"25px"}}>EDUCATION :-</p>
        </div>
      <div className='eduDiv2' >
          
          <div style={{alignItems:"center",textAlign:"start",}}>
              <h2 className='fswd'> <span style={{marginRight:"1rem"}}><FaBook color='var(--color-primary)' size={18}/></span>  FullStack Developer ( MERN )</h2>
              <h3 className='masai'>  <span  style={{marginRight:"1rem"}}><ImLocation className='masai1' color='var(--color-primary)' size={18}/></span>  Masai School, Bengluru, Karnataka</h3>
              <h4 className='present'> <span style={{marginRight:"1rem"}}> <FaCalendarAlt color='var(--color-primary)' size={16}/></span>  01/2022 - Present</h4>
          </div>
              <div style={{border:"1px solid white",backgroundColor:"white",marginTop:"2rem",marginBottom:"2rem"}}></div>
          <div style={{alignItems:"center"}}>
              <h2 className='fswd'> <span style={{marginRight:"1rem"}}><FaBook color='var(--color-primary)' size={18}/></span>BE Mechanical Engineering</h2>
              <h3 className='masai'>  <span style={{marginRight:"1rem"}}><ImLocation color='var(--color-primary)' size={18}/></span>BSIOTR, Pune University, Maharashatra</h3>
              <h4 className='present'> <span style={{marginRight:"1rem"}}> <FaCalendarAlt color='var(--color-primary)' size={16}/></span>07/2016 - 06/2019</h4>
          </div>
        </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5 >Experience ( Non-IT )</h5>
              <small style={{color:"#6b6767"}}> {"<"} 1 year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small style={{color:"#6b6767"}}>3+ Completed Projects</small>
            </article>
          </div>
          <h3 id='address'> Hello Everyone,  I'm <b>Vivek Nemade</b>  From Mumbai , Maharashtra , India. </h3>
           <p id='introself'> An ambitious and self-motivated Full Stack Web developer with
              considerable technical skills. Able to play a vital role in website
              development to ensure maximum accessibility, user experience
              and usability.
            </p>
          <a href="#contact" className="btn btn-primary">Let's Talk</a>
        </div>
      </div>

      
    </section>
  )
}

export default Intro1